import { Florder, FlorderTO } from '../../interfaces/florder.interface';
import { Florders, FlordersTO } from '../../interfaces/florders.interface';
import { initialState } from '../../interfaces/florders.model';
import { emptyPlace } from '../../interfaces/place.model';
import * as actions from './relocations.actions';
import { util } from '../../util/util';
import { Relocation } from 'app/core/interfaces/order.interface';
import { Place } from 'app/core/interfaces/place.interface';
import { Definitions } from 'app/core/store/definitions/definitions.interface';

export function reducer(state = initialState, action: actions.Actions): Florders {
  switch (action.type) {
    case actions.RELOCATIONS_CLEAR_FILTER: {
      return initialState;
    }

    case actions.RELOCATIONS_SET_FILTER: {
      return Object.assign({}, state, {
        filter: { ...action.payload.filter },
      });
    }

    case actions.RELOCATIONS_LOAD: {
      return Object.assign({}, state, {
        loading: true,
        filter: {
          ...state.filter,
          ...((action.payload && action.payload.filter) || state.filter)
        },
      });
    }

    case actions.RELOCATIONS_LOAD_SUCCESS: {
      const places = action.payload.places.reduce((res, place) => {
        return {
          ...res,
          [place.id]: place,
        };
      }, {});
      const items = mapFlordersTo2Relocations({...action.payload, places });
      return {
        loaded: true,
        loading: false,
        filterValues: state.filterValues,
        downloading: false,
        items: items.map(item => {
          return {
            ...item,
          };
        }),
        totalItems: action.payload.relocations.totalItems,
        filter: state.filter,
      };
    }

    case actions.RELOCATIONS_LOAD_FAIL: {
      return {
        loaded: false,
        loading: false,
        downloading: false,
        filterValues: state.filterValues,
        items: [],
        totalItems: null,
        filter: state.filter,
      };
    }

    default: {
      return state;
    }
  }
}

export function mapFlordersTo2Relocations({ relocations, places, definitions }: { relocations: FlordersTO; places: { [key: string]: Place }; definitions: Definitions }): Relocation[] {
  const items = relocations.items.map((relocation: FlorderTO) => {
    return {
      ...relocation,
      from: (relocation.from &&
        (places[relocation.from.id] ||
          Object.assign({}, emptyPlace, {
            id: relocation.from.id,
            name: relocation.from.name,
          }))) || { ...emptyPlace },
      to: (relocation.to &&
        (places[relocation.to.id] ||
          Object.assign({}, emptyPlace, {
            id: relocation.to.id,
            name: relocation.to.name,
          }))) || { ...emptyPlace },
      shippingCondition: (relocation.transport && definitions.transport.type.find(t => t.id === relocation.transport)) || {
        id: relocation.transport as string,
        name: relocation.transport as string,
      },
      globalType: (relocation.globalType && definitions.global.type.find(gt => gt.id === (relocation.globalType && (relocation.globalType as string).toUpperCase()))) || {
        id: relocation.globalType as string,
        name: relocation.globalType as string,
      }, // TODO hack voor fout MW.
      status: relocation.orderStatus && definitions.order.status.find(st => util.toNumber(st.id) === util.toNumber(relocation.orderStatus)),
      ccr: null,
      shipmentNumbers: relocation.shipmentNumber,
    } as Florder;
  });
  return items;
}

